export const TOP_AND_HOT_OK='top_and_hot_ok';
export const JUMP_URL='jump_url';
export const JUMP_LOGIN_OK='jump_login_ok';